import { render, staticRenderFns } from "./MultiDropZone.vue?vue&type=template&id=2096a646&scoped=true&"
import script from "./MultiDropZone.vue?vue&type=script&lang=js&"
export * from "./MultiDropZone.vue?vue&type=script&lang=js&"
import style0 from "./MultiDropZone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MultiDropZone.vue?vue&type=style&index=1&id=2096a646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096a646",
  null
  
)

export default component.exports